import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Card } from "../components/Layout";
const SuccessQuestion = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/");
    }, 2000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Container>
      <Card>
        <h1>🎉 Booking gennemført!</h1>
      </Card>
    </Container>
  );
};

export default SuccessQuestion;
